import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  // .use(ICU)
  .use(initReactI18next)
  .init({
    supportedLngs: ['es', 'ca', 'gl', 'eu'],
    fallbackLng: 'es',
    defaultNS: 'shared',
    ns: [
      'shared',
      'dashboard',
      'common',
      'auth',
      'activities',
      'cultivations',
      'parcels',
      'exploitations',
      'devices',
      'vehicles',
      'tools',
      'warehouses',
      'maps',
      'prices',
      'weather',
      'home',
      'profile',
      'help',
      'campaigns',
    ],
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path'],
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  })

export default i18n
